import { Injectable } from '@angular/core';
import {AngularFireDatabase, AngularFireList, AngularFireObject} from '@angular/fire/database';
import {Blog} from '../model/Blog';
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class BlogService {
  blogs: AngularFireList<Blog>;
  blog: AngularFireObject<Blog>;

  constructor(
    private db: AngularFireDatabase,
    private authService: AuthService
  ) {  }

  getBlogs() {
    this.blogs = this.db.list('blogs');
    return this.blogs;
  }

  createBlog(data: Blog) {
    this.blogs.push(data);
  }

  getBlogById(key: string) {
    this.blog = this.db.object('blogs/' + key);
    return this.blog;
  }

  updateBlog(data: Blog) {
    this.blogs.update(data.$key, data);
  }

  deleteBlog(key: string) {
    this.blogs.remove(key);
  }
}
